import { Row, Col } from "react-bootstrap";
import Courses from "../../mycomp/Dashboard/LMS/Courses";

const SuperOrganization = () => {
    return (
        <>
        <Row>
            <Col xs={12} sm={12} lg={12} xl={12} xxl={12}>
                <Courses />
            </Col>
        </Row>
        </>
    );
};

export default SuperOrganization;